export const random = (inferior: number, superior: number) => {
    const range = superior - inferior + 1;
    const array = new Uint32Array(1);
    crypto.getRandomValues(array);

    const randomNumber = array[0];
    const offset = randomNumber % range;

    return inferior + offset;
};
